// Populate the following with
// Firebase config object (https://firebase.google.com/docs/web/setup#config-object).
// Then, rename this file to "firebase_config.js".
export const firebaseConfig = {
  apiKey: "AIzaSyDjd1ypmqJpVFG4-5AMRJfCQP8Hk-3qlAg",
  authDomain: "pikachuvolleyball-78efc.firebaseapp.com",
  databaseURL: 'https://pikachuvolleyball-78efc.firebaseapp.com',
  projectId: "pikachuvolleyball-78efc",
  storageBucket: "pikachuvolleyball-78efc.firebasestorage.app",
  messagingSenderId: "167575802911",
  appId: "1:167575802911:web:55287e271a1ad9a326f12a",
  measurementId: "G-XEM1XYJM62"
};